module.exports = __webpack_public_path__ + "assets/civil-equip-operator.svg?31c6999c6bb67b69c6beffd1db85df3d";